import React from 'react';
import { 
  Container
  , DateText
  , VitalLabel
  , VitalValue
  , VitalUnit
} from './CustomTooltip.styled';

interface CustomTooltipProps {
  active?: boolean;
  payload?: any[];
  label?: string;
  chartData: any[];
}

/**
 * カスタムツールチップコンポーネント
 * グラフホバー時に詳細情報を表示
 */
export const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, chartData }) => {
  if (!active || !payload || payload.length === 0) return null;

  // オリジナルの日付情報を取得するため、chartDataから検索
  const dateLabel = payload[0]?.payload?.date;
  if (!dateLabel) return null;

  // chartDataから元の日付を探す
  const dataPoint = chartData.find(d => d.date === dateLabel);
  if (!dataPoint || !dataPoint.originalDate) return null;

  const date = new Date(dataPoint.originalDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];

  // 元のデータポイントから値を取得
  const bloodPressureSys = dataPoint.blood_pressure_sys;
  const bloodPressureDia = dataPoint.blood_pressure_dia;
  const pulse = dataPoint.pulse;
  const temperature = dataPoint.temperature;
  const spo2 = dataPoint.spo2;
  const hydration = dataPoint.hydration_ml;

  return (
    <Container>
      <DateText>{month}月{day}日({dayOfWeek})</DateText>
      {temperature != null && (
        <VitalLabel>
          体温 <VitalValue>{temperature.toFixed(1)}</VitalValue><VitalUnit>°C</VitalUnit>
        </VitalLabel>
      )}
      {bloodPressureSys != null && bloodPressureDia != null && (
        <VitalLabel>
          血圧 <VitalValue>{bloodPressureSys}/{bloodPressureDia}</VitalValue><VitalUnit>mmHg</VitalUnit>
        </VitalLabel>
      )}
      {pulse != null && (
        <VitalLabel>
          脈拍 <VitalValue>{pulse}</VitalValue><VitalUnit>bpm</VitalUnit>
        </VitalLabel>
      )}
      {spo2 != null && (
        <VitalLabel>
          SpO2 <VitalValue>{spo2}</VitalValue><VitalUnit>%</VitalUnit>
        </VitalLabel>
      )}
    </Container>
  );
};

export default CustomTooltip;
